var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { GrayText, PageLayout, withAnalytics, withGraphqlErrorFlags, withLoadingSpinner, withMountTracking, withShowFlag, graphql, compose, } from "@atlassiansox/microscopekit";
import { withServiceNotFoundHandler } from "@atlassiansox/microscopekit/dist/src/error/with-service-not-found-handler";
import releaseDetailsQuery from "../models/service-release-details.query.graphql";
import './release-history.css';
import { Releases } from "./ReleasesView";
var ReleasesHistoryView = /** @class */ (function (_super) {
    __extends(ReleasesHistoryView, _super);
    function ReleasesHistoryView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pageSize = 25;
        return _this;
    }
    ReleasesHistoryView.prototype.componentDidMount = function () {
        document.title = this.props.data.service.id + " | Releases";
    };
    ReleasesHistoryView.prototype.componentWillUnmount = function () {
        document.title = "Microscope";
    };
    ReleasesHistoryView.prototype.render = function () {
        this.props.track("Release history opened", { category: 'info', id: this.props.data.service.id });
        if (this.props.data == null || this.props.data.service == null || this.props.data.service.releaseHistory.environments.length === 0) {
            return (React.createElement(PageLayout, { title: "Release History" },
                React.createElement(GrayText, { bold: true }, "No releases recorded for this service.")));
        }
        return (React.createElement(Releases, __assign({}, {
            id: this.props.data.service.id,
            env: this.props.data.service.releaseHistory.environments[0],
            page: 0,
            pageSize: this.pageSize,
        }, { environments: this.props.data.service.releaseHistory.environments })));
    };
    return ReleasesHistoryView;
}(React.Component));
export { ReleasesHistoryView };
export var ReleasesHistoryPage = compose(graphql(releaseDetailsQuery, {}), withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, withServiceNotFoundHandler, withMountTracking("ReleasesHistoryView"), withAnalytics)(ReleasesHistoryView);
